interface FormattedTemplateProps {
  iconUrl?: string;
  name?: string;
  closePopUp: () => void;
}
import Image, { ImageLoaderProps } from 'next/image';
import styled from '@emotion/styled';
import { Button } from '@mui/material';

const LogoImage = styled(Image)(({ theme }) => ({
  height: '100% !important',
  minHeight: ' 100% !important',
  width: 'auto !important',
  minWidth: 'auto !important',
  margin: '0 !important',
}));

const ModalContainer = styled.div`
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  background: #0000006e
`;

const Modal = styled.div`
  margin-top: 16px;
  background: white;
  width: 350px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 12px 12px;
  text-align: center;
`;

const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 12px 12px 0px 0px;
  padding: 0 16px;
  p {
    margin-left: 8px;
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
`;

export const StagePopup = ({ iconUrl, name, closePopUp }: FormattedTemplateProps) => (
  <ModalContainer>
    <Modal>
      <ModalHeader>
        <LogoImage
          loader={({ src }: ImageLoaderProps) => src}
          unoptimized={true}
          width={40}
          height={40}
          src={`${iconUrl}`}
          alt={'logo-inner-url'}
        />
        <div>
          <p id="aeriagamesHighscoreTitle">{name}</p>
        </div>
      </ModalHeader>
      <ModalBody>
        <Button onClick={closePopUp} variant="contained" style={{ background: '#00a2f2', color: 'white' }}>
          ゲームを続ける
        </Button>
        <a style={{ marginTop: '24px',color: '#00a1a3',fontSize: '12px', textDecoration: 'underline' }} href="https://games.yahoo.co.jp/play" target="_blank" rel="noreferrer">
          かんたんゲーム一覧へ ＞
        </a>
      </ModalBody>
    </Modal>
  </ModalContainer>
);
